import { useGetNoticesFromNoticeTypeMutation } from '@frontend/redux';
import withNoticeList from './withNoticeList';

const NoticesByTypes = withNoticeList(
  useGetNoticesFromNoticeTypeMutation
);

export default NoticesByTypes;